export default __webpack_public_path__ + "static/media/img_no_recipe.c98665aa.svg";